export const CONNECTION_ERROR_MESSAGE = "接続に失敗しました\n通信環境を確認の上、再試行してください";
